module.exports = __webpack_public_path__ + "media/images/lig/logo-lig-white-cc0229daa2593ee9f031f1c60513a46d.svg";